import { Box, Typography } from '@mui/material'
import React from 'react'
import blogo from '../Assests/billLogo.png';
import { BRAND, formatAddress } from '../constants/brand';

function Home() {
    return (
        <>
            {/* <Box sx={{ width: '100vw', height: '100vh', background: '#02847A', display: 'flex', justifyContent: 'center', alignItems: 'center' }}> */}
            <Box sx={{ width: '100vw', height: '100vh', background: '#FFFFFF', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 3 }}>
                <img
                    src={blogo}
                    alt='mainLogo'
                    draggable={false}
                    height='60%'
                />
               
            </Box>



        </>
    )
}

export default Home
